import WebSummary from "@/pages/Summary/Web";
import { useEffect } from "react";
import recordStore from "@/store/record.store";
import summaryCommonStore from "@/store/summaryCommon.store";
import { maxMobileWidth } from "@/constants/share";
import MobileSummaryWrap from "@/sections/MobileSummaryWrap";

export default function Summary() {
  const queryParams = new URLSearchParams(window.location.search);
  const streamId = queryParams.get("streamId") || "";
  const summaryKey = summaryCommonStore((state) => state.summaryKey);

  useEffect(() => {
    if (streamId) {
      summaryCommonStore.getState().setStreamId(streamId);
    }
    recordStore.getState().resetRecentSpeakers();
    return () => {
      summaryCommonStore.getState().initStore();
      recordStore.getState().resetStore();
    };
  }, []);

  return (
    <>
      {document.documentElement.clientWidth <= maxMobileWidth ? (
        <MobileSummaryWrap key={summaryKey} />
      ) : (
        <WebSummary key={summaryKey} />
      )}
    </>
  );
}
